import { render } from "./DemoPage2.vue?vue&type=template&id=20ee83fc"
import script from "./DemoPage2.vue?vue&type=script&lang=js"
export * from "./DemoPage2.vue?vue&type=script&lang=js"

import "./DemoPage2.vue?vue&type=style&index=0&id=20ee83fc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__